'kiwi public';

import GlobalApi from '@/libs/GlobalApi';
import MessageList from './MessageList';
import NetworkSettings from './NetworkSettings';
import ChannelList from './ChannelList';
export default {
  components: {
    MessageList: MessageList,
    NetworkSettings: NetworkSettings,
    ChannelList: ChannelList
  },
  props: ['network'],
  data: function data() {
    return {
      pluginUiElements: GlobalApi.singleton().serverViewPlugins
    };
  },
  computed: {
    hasMessages: function hasMessages() {
      return this.network.serverBuffer().getMessages().length > 0;
    },
    serverBuffer: function serverBuffer() {
      return this.network.serverBuffer();
    },
    restrictedServer: function restrictedServer() {
      return this.$state.setting('restricted');
    },
    networkConnected: function networkConnected() {
      return this.network.state === 'connected';
    }
  },
  watch: {
    networkConnected: function networkConnected() {
      var _this = this;
      this.$nextTick(function () {
        // Vue won't update the tabs being displayed here so we to
        // manually update a property to force a re-render of the tabs
        _this.$refs.tabs.a++;
      });
    }
  },
  created: function created() {
    var _this2 = this;
    this.listen(this.$state, 'server.tab.show', function (tabName) {
      _this2.showTab(tabName);
    });
  },
  mounted: function mounted() {
    this.serverBuffer.active_tab = this.hasMessages ? 'messages' : 'settings';
  },
  methods: {
    showTab: function showTab(tabName) {
      this.$refs.tabs.setActiveByName(tabName);
    },
    tabChanged: function tabChanged(tabName) {
      var isMessages = tabName === 'messages';
      this.serverBuffer.active_tab = tabName;
      this.serverBuffer.isVisible = isMessages;
      this.serverBuffer.show_input = isMessages;
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["ServerView"]
window._kiwi_exports.components.ServerView = (typeof exports !== 'undefined' ? (exports.default || exports) : (typeof module !== 'undefined' && module.exports ? (module.exports.default || module.exports) : {}));
